<template>
  <ReportAgent
    :urls="urls"
    :mandatory-filter="[
      {
        name: 'date_range',
        title: 'Date range',
        valueFieldName: '.date',
      },
    ]"
  />
</template>

<script>
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import ReportAgent from "@/own/components/reports/ReportAgent";
export default {
  name: "ReportOrderSkuSerial",
  components: { ReportAgent },
  data: () => ({
    urls: {
      data_url: "/reports/reportOrderSkuSerial",
      show_url: "/reports/reportOrderSkuSerial/show",
    },
  }),
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
  },
};
</script>
